import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';

const TabList = styled.ul`
    display: flex;
    padding: 0;
    margin: 0;
    height: 60px;
    align-items: stretch;
    justify-content: space-between;
    border-bottom: 1px solid ${ theme.palette.silver };
    flex: 1 0 auto;
`;

const TabContent = styled.div`
    padding: 1rem;
    border: solid ${ theme.palette.silver };
    border-width: 0 1px 1px 1px;
    background-color: ${ theme.palette.white };
`;

class Tabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedIndex: 0,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { selectedIndex } = this.state;

        if (nextState.selectedIndex !== selectedIndex) {
            return true;
        }

        return false;
    }

    onClickTabItem = (index) => {
        this.setState({
            selectedIndex: index,
        });
    }

    render() {
        const { children, name, style } = this.props;
        const { selectedIndex } = this.state;

        const childrenWithProps = React.Children.map(children, (child, index) => {
            const { label } = child.props;

            return React.cloneElement(child, {
                index: index,
                key: `${ name }_${ label }`,
                label: label,
                onClick: this.onClickTabItem,
                selectedIndex: selectedIndex,
            });
        });

        return (
            <div
                id={ name }
                className='tabs'
                style={ style }
            >
                <TabList>
                    { childrenWithProps }
                </TabList>

                <TabContent>
                    {
                        React.cloneElement(children[selectedIndex].props.children)
                    }
                </TabContent>
            </div>
        );
    }
}

Tabs.defaultProps = {
    name: 'Tabs',
    style: {},
};

Tabs.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.array,
    ]).isRequired,
    name: PropTypes.string,
    style: PropTypes.object,
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/tabs/Tabs.js